import { render, staticRenderFns } from "./EditBarView.vue?vue&type=template&id=44403c5a&scoped=true&"
import script from "./EditBarView.vue?vue&type=script&lang=js&"
export * from "./EditBarView.vue?vue&type=script&lang=js&"
import style0 from "./EditBarView.vue?vue&type=style&index=0&id=44403c5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44403c5a",
  null
  
)

export default component.exports